import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/god`;

export const getUsers = () => {
  return axiosInstance.get(`${PREFIX}/users`);
};

export const impersonateUser = userId => {
  return axiosInstance.post(`${PREFIX}/users/login`, null, {
    params: { userId }
  });
};

export const updatePassword = (userId, password) => {
  return axiosInstance.put(
    `${PREFIX}/users/password`,
    {},
    {
      params: {
        password: password,
        userId: userId
      }
    }
  );
};

export const getAuditLogs = ({ fromDate, toDate, page, size, source, userId, createdAt } = {}) => {
  const params = { page, size };
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (source) params.source = source;
  if (userId) params.userId = userId;
  if (createdAt) params.createdAt = createdAt;
  return axiosInstance.get(`${PREFIX}/api-audit-logs`, { params });
};

export const getMipsPrompt = () => {
  return axiosInstance.get(`${PREFIX}/mips-prompt`);
};

export const updateMipsPrompt = mipsPrompt => {
  return axiosInstance.put(`${PREFIX}/mips-prompt`, { mipsPrompt });
};

export const getCopyEligibleUsers = type => {
  return axiosInstance.get(`${PREFIX}/users/templates-k2ps/copy-eligible`, {
    params: { type }
  });
};

export const copyK2PTemplates = (sourceUserId, targetUserId) => {
  return axiosInstance.post(
    `${PREFIX}/users/templates-k2ps/copy`,
    null,
    { params: { sourceUserId, targetUserId } }
  );
};
